const DETAILS_EMAIL_SET = 'DETAILS_EMAIL_SET';
const DETAILS_EMAIL_SET_VALIDATION_MESSAGE = 'DETAILS_EMAIL_SET_VALIDATION_MESSAGE';
const DETAILS_EMAIL_SET_VISUALIZATION = 'DETAILS_EMAIL_SET_VISUALIZATION';
const DETAILS_EMAIL_SET_API_ERROR = 'DETAILS_EMAIL_SET_API_ERROR';
const DETAILS_EMAIL_SET_FOCUS = 'DETAILS_EMAIL_SET_FOCUS';
const DETAILS_EMAIL_BLURRED = 'DETAILS_EMAIL_BLURRED';
const DETAILS_EMAIL_FOCUSED = 'DETAILS_EMAIL_FOCUSED';
const DETAILS_EMAIL_CHANGE = 'DETAILS_EMAIL_CHANGE';

const accountEmailSet = (email) => ({
  type: DETAILS_EMAIL_SET,
  payload: email
});

const accountEmailSetValidationMessage = (error) => ({
  type: DETAILS_EMAIL_SET_VALIDATION_MESSAGE,
  payload: error
});

const accountEmailSetVisualization = (visualized) => ({
  type: DETAILS_EMAIL_SET_VISUALIZATION,
  payload: visualized
});

const accountEmailSetApiError = (apiError) => ({
  type: DETAILS_EMAIL_SET_VISUALIZATION,
  payload: apiError
});

const accountEmailSetFocus = (focused) => ({
  type: DETAILS_EMAIL_SET_FOCUS,
  payload: focused
});

const accountEmailBlur = (markedAsWrong, validationMessage) => ({
  type: DETAILS_EMAIL_BLURRED,
  payload: {
    markedAsWrong,
    validationMessage
  }
});

const accountEmailChange = (payload) => ({
  type: DETAILS_EMAIL_CHANGE,
  payload
});

const accountEmailFocus = () => ({
  type: DETAILS_EMAIL_FOCUSED
});

export {
  accountEmailSetValidationMessage,
  accountEmailSetVisualization,
  accountEmailFocus,
  accountEmailSetFocus,
  accountEmailSetApiError,
  accountEmailBlur,
  accountEmailSet,
  accountEmailChange,
  DETAILS_EMAIL_CHANGE,
  DETAILS_EMAIL_FOCUSED,
  DETAILS_EMAIL_BLURRED,
  DETAILS_EMAIL_SET_FOCUS,
  DETAILS_EMAIL_SET_API_ERROR,
  DETAILS_EMAIL_SET_VALIDATION_MESSAGE,
  DETAILS_EMAIL_SET,
  DETAILS_EMAIL_SET_VISUALIZATION
};

